const readText = (value: unknown): string => String(value ?? '').trim();

const parseMonthDay = (value: unknown): { monthIndex: number; day: number } => {
  const raw = readText(value);
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(raw);
  if (!match) {
    return { monthIndex: 8, day: 1 };
  }
  return {
    monthIndex: Math.max(0, Math.min(11, Number(match[2]) - 1)),
    day: Math.max(1, Math.min(31, Number(match[3]))),
  };
};

export const deriveAcademicYearLabel = (
  referenceDate: Date = new Date(),
  academicYearStartDate?: string | null,
): string => {
  const { monthIndex, day } = parseMonthDay(academicYearStartDate);
  const currentYear = referenceDate.getFullYear();
  const startsThisYear = new Date(currentYear, monthIndex, day);
  const startYear = referenceDate >= startsThisYear ? currentYear : currentYear - 1;
  return `${startYear}-${startYear + 1}`;
};

export const resolveAcademicYearLabel = (
  academicYear: unknown,
  referenceDate: Date = new Date(),
): string => {
  const record =
    academicYear && typeof academicYear === 'object' && !Array.isArray(academicYear)
      ? (academicYear as Record<string, unknown>)
      : {};
  const override = readText(record.labelOverride);
  if (override) {
    return override;
  }
  return deriveAcademicYearLabel(referenceDate, readText(record.startDate));
};

export const readAcademicYearLabelOverride = (academicYear: unknown): string => {
  const record =
    academicYear && typeof academicYear === 'object' && !Array.isArray(academicYear)
      ? (academicYear as Record<string, unknown>)
      : {};
  return readText(record.labelOverride);
};
